import React, { useEffect, useState, ReactNode } from 'react';
import { useAccess } from '@umijs/max';
import { Button } from 'antd';

export type ProButtonType = {
  auth?: string;
  hide?: string;
  disabled?: boolean;
  custom?: boolean;
  Children: ReactNode; // 关键修复
  onClick?: () => Promise<void>;
  title?: any;
  fieldProps?: any;
};

const ProButton = (props: any) => {
  const access = useAccess();
  let [getauth, setauth] = useState<boolean>(false);
  useEffect(() => {
    init();
  }, []);
  const init = async () => {
    if (props.auth) {
      let res = (await access).canReadButton(props.auth);
      setauth(res);
    }
  };

  return (
    <span>
      {[
        !getauth && props.disabled !== undefined && (
          <Button
            key={props.auth}
            className={props.className}
            style={{ minwidth: '20px' }}
            disabled={true}
            {...props.fieldProps}
            onClick={props.onClick}
          >
            {props.title}
          </Button>
        ),
        getauth && props.disabled === undefined && !props.custom && (
          <Button
            key={props.auth}
            className={props.className}
            style={{ minwidth: '20px' }}
            {...props.fieldProps}
            onClick={props.onClick}
          >
            {props.title}
          </Button>
        ),
        getauth && props.disabled === undefined && props.custom && (
          <div key={props.auth} className={props.className}>{props.children}</div>
        ),
      ]}
    </span>
  );
};
export default ProButton;
